<template>
  <div>
    <el-card class="box-card tablecard" shadow="never">
      <div slot="header" class="clearfix textLeft">
        <span><i class="fa fa-gift fs14" /> Statistics of public projects by journal </span>
      </div>
      <div>
        <!-- <h3>{{htitle}} 下载排行</h3> -->
        <div class="mb10 textRight">
          Search: <el-input size="medium" v-model="searchkey" placeholder="" class="searchInput mr5" clearable></el-input>
            <el-button class="submitbtn" @click="handleSearch">Search</el-button>
        </div>
        <el-table
          v-loading="loading"
          @sort-change="handleSort"
          @current-change="handleCurrentChange"
          :data="sData"
          height="800"
          border
          stripe
          style="width: 100%">
          <el-table-column
            prop="journal"
            label="Journal"
            :show-overflow-tooltip="isOverflow"
            width="200"
            sortable>
            <template slot-scope="scope">
              <span class="tablelink" @click="handleprolist(scope.row.journal)">
                {{scope.row.journal}}
              </span>
            </template>
          </el-table-column>
          <el-table-column :label="year">
            <el-table-column
              :prop="'if_'+year"
              label="IF"
              width="100"
              sortable>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="isOverflow"
              :prop="'projects_'+year"
              label="Projects"
              width="110"
              sortable>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="year-1">
            <el-table-column
              :prop="'if_'+(year-1)"
              label="IF"
              width="100"
              sortable>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="isOverflow"
              :prop="'projects_'+(year-1)"
              label="Projects"
              width="110"
              sortable>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="year-2">
            <el-table-column
              :prop="'if_'+(year-2)"
              label="IF"
              width="100"
              sortable>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="isOverflow"
              :prop="'projects_'+(year-2)"
              label="Projects"
              width="110"
              sortable>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="year-3">
            <el-table-column
              :prop="'if_'+(year-3)"
              label="IF"
              width="100"
              sortable>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="isOverflow"
              :prop="'projects_'+(year-3)"
              label="Projects"
              width="110"
              sortable>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="year-4">
            <el-table-column
              :prop="'if_'+(year-4)"
              label="IF"
              width="100"
              sortable>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="isOverflow"
              :prop="'projects_'+(year-4)"
              label="Projects"
              width="110"
              sortable>
            </el-table-column>
          </el-table-column>
          <el-table-column
            width="130"
            prop="projects_recent"
            label="Recent 5 years projects"
            sortable>
          </el-table-column>
          <el-table-column
            width="140"
            prop="projects_total"
            label="Total projects"
            sortable>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="allNum"
          :page-size="pageSize"
          @current-change="handleChangepage"
          class="pagination mb10">
        </el-pagination>
      </div>
    </el-card>
    <el-card class="box-card tablecard mt10" shadow="never" v-show="isShow">
      <div slot="header" class="clearfix textLeft">
        <span><i class="fa fa-cogs fs14" /> Project Information List</span>
      </div>
      <div>
        <el-table
          border
          stripe
          v-loading="loadingpro"
          :data="tableData"
          style="width: 100%"
          :row-key="getRowKeys"
          @sort-change="handleSortpro"
          :expand-row-keys="expands"
          @expand-change="handleExpandpro">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table
                border
                v-loading="subloading"
                :data="props.row.subtableData"
                style="width: 100%">
                <!-- <el-table-column
                  prop=""
                  label=" "
                  width="50">
                </el-table-column> -->
                <el-table-column
                  prop="subtitle_en"
                  label="Subproject Title"
                  width="210"
                  :show-overflow-tooltip="isOverflow">
                  <template slot-scope="scope">
                    <span class="tablelink" @click="handlesubProurl(scope.row.subproject_id)">
                      {{scope.row.subtitle_en}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="subproject_id"
                  label="Subproject ID">
                </el-table-column>
                <el-table-column
                  prop="px_id"
                  label="PXID">
                </el-table-column>
                <el-table-column
                  prop="species"
                  label="Species">
                </el-table-column>
                <el-table-column
                  prop="instrument"
                  label="Instrument"
                  :show-overflow-tooltip="isOverflow">
                </el-table-column>
                <el-table-column
                  prop="fileCount"
                  label="File Count (size)">
                </el-table-column>
                <el-table-column
                  prop="submit_time"
                  label="Release Date">
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column
            label="ProjectName"
            prop="project_title_english"
            width="240"
            :show-overflow-tooltip="isOverflow"
            sortable>
            <template slot-scope="scope">
              <span class="tablelink" @click="handleProurl(scope.row.project_id)">
                {{scope.row.project_title_english}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="ProjectID"
            prop="project_id"
            width="122"
            :show-overflow-tooltip="isOverflow"
            sortable>
          </el-table-column>
          <el-table-column
            label="Submission Type"
            prop="submission_type"
            width="104"
            :show-overflow-tooltip="isOverflow">
          </el-table-column>
          <el-table-column
            label="PXID"
            prop="px_id"
            width="98"
            :show-overflow-tooltip="isOverflow"
            sortable>
          </el-table-column>
          <el-table-column
            label="Publication"
            prop="pubmed_id"
            :show-overflow-tooltip="isOverflow">
            <template slot-scope="scope">
              <span>
                <a :href="publictionUrl+scope.row.pubmed_id">{{scope.row.pubmed_id}}</a>
                {{scope.row.reference}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="Submitter"
            prop="submitter"
            width="120"
            :show-overflow-tooltip="isOverflow"
            sortable>
          </el-table-column>
          <el-table-column
            label="Labhead"
            prop="lab_header"
            width="120"
            :show-overflow-tooltip="isOverflow"
            sortable>
          </el-table-column>
          <el-table-column
            label="Institution"
            prop="institution_english"
            :show-overflow-tooltip="isOverflow"
            sortable>
          </el-table-column>
          <el-table-column
            label="Subproject Count"
            prop="sub_count"
            width="100"
            :show-overflow-tooltip="isOverflow"
            sortable>
          </el-table-column>
          <el-table-column
            label="Releasedate"
            prop="submit_time"
            :show-overflow-tooltip="isOverflow"
            sortable>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="allNumpro"
          :page-size="pageSizepro"
          @current-change="handleChangepagepro"
          class="pagination mb10">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getStatProjectsByJournal, getSearchProjectList, getSearchSubProjectList } from '@/api'
// import echarts from 'echarts'
export default {
  name: 'statistics',
  data() {
    return {
      publictionUrl: 'http://www.ncbi.nlm.nih.gov/pubmed?term=',
      sData: [],
      loading: false,
      allNum: 0,
      pageSize: 20,
      searchkey: '',
      isOverflow: true,
      ajax_data: {
        search:{
          journal: ''
        },
        page:{
          startPage: 1,
          pageLength: 20
        },
        order:{
          item: 'journal',
          type: 'desc'
        }
      },
      year: 0,
      orderConvert: {
        ascending: 'asc',
        descending: 'desc'
      },
      ajax_data_list: {
        search:{
          journal: '',
          sub: ''
        },
        page:{
          startPage: 1,
          pageLength: 20
        },
        order:{
          item: '',
          type: ''
        }
      },
      ajax_data_sublist: {
        search:{
          project_id: '',
          object_type: '',
          object_value: ''
        },
        page:{
          startPage: 1,
          pageLength: 20
        },
        order:{
          item: '',
          type: ''
        }
      },
      pageSizepro: 20,
      allNumpro: 0,
      expands: [],
      getRowKeys (row) {
        return row.project_id
      },
      loadingpro: false,
      subloading: true,
      tableData: [],
      isShow: false
    }
  },
  mounted() {
    // const currentYear = new Date().getFullYear();
    // let years = [];
    // for (let i = 0; i < 5; i++) {
    //   years.push(currentYear - i);
    // }
    // this.years = years
    // console.log(years);
  },
  created() {
    getStatProjectsByJournal(this.ajax_data).then(res => {
      this.sData = res.result[0].list
      this.allNum = res.count
      this.year = res.result[0].year
    })
  },
  methods: {
    handleProurl(param) {
      let routerData = this.$router.resolve({path: '/project', query: {id: param}})
      window.open(routerData.href, '_blank')
    },
    handlesubProurl(param) {
      let routerData = this.$router.resolve({path: '/subproject', query: {id: param}})
      window.open(routerData.href, '_blank')
    },
    handleChangepage(val) {
      this.loading = true
      this.ajax_data.page.startPage = val
      getStatProjectsByJournal(this.ajax_data).then(res => {
        this.loading = false
        // console.log(res)
        this.sData = res.result[0].list
        this.allNum = res.count
      })
    },
    handleSort (column, prop, order) {
      // console.log(column, prop, order)
      this.loading = true
      this.ajax_data.order.item = column.prop
      this.ajax_data.order.type = this.orderConvert[column.order]
      if (column.order !== null && column.prop !== null) {
        getStatProjectsByJournal(this.ajax_data).then(res => {
          this.loading = false
          this.sData = res.result[0].list
          this.allNum = res.count
        })
      } else {
        this.loading = false
      }
    },
    handleSearch() {
      this.loading = true
      this.ajax_data.search.journal = this.searchkey
      getStatProjectsByJournal(this.ajax_data).then(res => {
        this.loading = false
        // let newData = res.result
        // newData.forEach((val, index) => {
        //   let fileCount = val.file_count;
        //   let fileSize = this.handleFilesize(val.file_size)
        //   val.fileCount = fileCount + fileSize
        // })
        this.sData = res.result[0].list
        this.allNum = res.count
      })
    },
    showDate() {
      var xhr = new XMLHttpRequest();
      //使用HEAD获取当前页面的响应头
      xhr.open('HEAD', window.location.href);
      xhr.onreadystatechange = function () {
        //等待响应完成
          if (this.readyState === this.DONE) {
            //响应完毕后修改时区为东八区为准
            var serverTime = xhr.getResponseHeader('Date');
            var offset = new Date().getTimezoneOffset() / 60;
            var chinaTime = new Date(new Date(serverTime).getTime() + offset * 60 * 60 * 1000 + 8 * 60 * 60 * 1000);
            // 获取当前服务器时间的年份
            let year = chinaTime.getFullYear();
            //输出当前时间与年份
            console.log(chinaTime);
            console.log(year);
            return year;
            // let newyears = [];
            // for (let i = 0; i < 5; i++) {
            //   newyears.push(year - i);
            // }
            // return newyears;
            // this.years = newyears
            // console.log(this.years); 
          }
      };
      xhr.send();
    },
    handleCurrentChange(val) {
      console.log(val)
    },
    handleprolist(val) {
      this.ajax_data_list.search.journal = val
      getSearchProjectList(this.ajax_data_list).then(res => {
        this.isShow = true
        this.loadingpro = false
        this.tableData = res.result
        this.allNumpro = res.count
      })
    },
    handleFilesize(param) {
      let fileSize = param;
      if (fileSize == 0 || fileSize == null) {
        fileSize = ' (' + 0 +'K)';
      } else if (fileSize < 1024) {
        fileSize = ' (' + fileSize.toFixed(2) + 'K)';
      } else if (fileSize >= 1024 && fileSize < 1024 * 1024) {
        fileSize =  ' (' + (fileSize / 1024).toFixed(2)+ 'M)'
      } else {
        fileSize =   ' ('
          + (fileSize / 1024 / 1024).toFixed(2)
          + 'G)'
      }
      return fileSize
    },
    handleExpandpro(row, expandedRows) {
      this.subloading = true
      console.log(row, expandedRows)
      this.expands = []
      if (expandedRows.length) {
        expandedRows.map((item, key) => {
          this.expands.push(item.project_id)
        })
        this.ajax_data_sublist.search.project_id = row.project_id
        // this.ajax_data_sublist.search.object_type = this.kindVal
        // this.ajax_data_sublist.search.object_value = this.subparams
        this.ajax_data_sublist.page.startPage = 1
        getSearchSubProjectList(this.ajax_data_sublist).then(res => {
          this.subloading = false
          let newData = res.result
          newData.forEach((val, index) => {
            let fileCount = val.file_count;
            let fileSize = this.handleFilesize(val.file_size)
            val.fileCount = fileCount + fileSize
          })
          let subList = newData
          // console.log(subList)
          row.subtableData = subList
        })
      } else {
        this.expands = []
      }
    },
    handleSortpro(column, prop, order) {
      // console.log(column, prop, order)
      this.loadingpro = true
      this.ajax_data_list.order.item = column.prop
      this.ajax_data_list.order.type = this.orderConvert[column.order]
      if (column.order !== null && column.prop !== null) {
        getSearchProjectList(this.ajax_data_list).then(res => {
          this.loadingpro = false
          this.tableData = res.result
          this.allNumpro = res.count
        })
      } else {
        this.loadingpro = false
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
